module.exports = __webpack_public_path__ + "static/media/alertYellow.915b9b5f.svg";